import React from 'react'
import './index.scss'
import { background } from 'assets/backgrounds'
import LawTech from './components/lawtech'
import { Button } from 'cwp-components/forms/Buttons'
import FundedBy from './components/funded-by'
import PioneerSection from './components/pioneer'
import { Link } from 'react-router-dom'

const WhoWeAre = () => {
  return (
    <>
      <section id='who-we-are' className='md:p-10 py-10 px-5'>
        <div className='relative'>
          <div className='grid md:grid-cols-[40%_50%] grid-cols-2 md:place-items-center place-content-center'>
            <div className=''>
              <h1 className='md:text-[64px] text-[24px] max-sm:mt-[50px] max-sm:ml-[20px] font-bold text-[#020251]'>
                We help you with your{' '}
                <span className='text-[#65C2D7]'>legal needs</span>
              </h1>
              <p className='md:px-[20px] ml-10 mt-[60px] md:mt-10 md:mr-0 mr-[-200px] md:font-bold font-[400] md:text-[18px] text-[12px] text-[rgba(51,27,59,0.66)] '>
                Legal Utopia is a pioneering legal technology company dedicated
                to making legal services more accessible and affordable for
                everyone. We leverage advanced AI and intuitive design to
                provide comprehensive legal solutions tailored to individual
                needs.{' '}
                <span className='md:inline block md:ml-0 ml-10 md:mt-0 mt-5'>
                  Our mission is to demystify the legal process and empower
                  users with the knowledge and tools necessary to navigate their
                  legal challenges confidently.
                </span>
              </p>
            </div>
            <div className=''>
              <img
                className='md:t-0 mt-5'
                src={background.WhoWeAre.Hero}
                alt=''
              />
            </div>
          </div>
          <img
            className='absolute left-[-10px] md:top-[180px] top-[50px] md:h-[1300px]'
            src={background.WhoWeAre.Tree}
            alt=''
          />
          <div className='flex justify-end'>
            <Button className='!p-[6px_12px] !bg-[#020251] text-white mt-[300px] md:mt-[50px] md:mr-[150px]'>
              <Link to='https://www.legalutopia.co.uk/find-a-lawyer/search'>
                Get help today
              </Link>
            </Button>
          </div>
        </div>

        <div className='flex justify-end items-center mt-[100px]'>
          <div className='col-md-4 md:mr-[200px] relative'>
            <div className='upper md:p-[30px] p-5 absolute md:right-[-100px] right-[-10px] top-0 md:w-[90%] w-[70%]'>
              <p className='md:text-[32px] font-bold text-center '>
                We envision a world where law is for everyone.
              </p>
            </div>
            <div className='card md:p-[40px] p-4 mt-[80px] md:mt-[120px] md:space-y-[18px]'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='18'
                height='16'
                viewBox='0 0 18 16'
                fill='none'
              >
                <path
                  fill-rule='evenodd'
                  clip-rule='evenodd'
                  d='M6.42708 0.558005C2.66208 2.976 0.570575 5.79 0.152075 9.0015C-0.499425 14 3.97057 16.4465 6.23557 14.2485C8.50058 12.05 7.14307 9.26 5.50307 8.497C3.86307 7.7345 2.86008 8 3.03508 6.9805C3.21008 5.9615 5.54307 3.1355 7.59307 1.8195C7.66572 1.75773 7.71207 1.67057 7.72266 1.5758C7.73325 1.48103 7.70729 1.38579 7.65007 1.3095L7.14307 0.650005C6.92308 0.364005 6.71208 0.375004 6.42708 0.557504M16.3401 0.558005C12.5751 2.976 10.4831 5.7905 10.0651 9.0015C9.41358 14 13.8836 16.4465 16.1486 14.2485C18.4136 12.05 17.0561 9.26 15.4156 8.497C13.7756 7.7345 12.7726 8 12.9476 6.9805C13.1226 5.9615 15.4561 3.1355 17.5061 1.8195C17.5786 1.75766 17.6249 1.67047 17.6354 1.5757C17.6459 1.48093 17.6198 1.38573 17.5626 1.3095L17.0556 0.650005C16.8356 0.364005 16.6246 0.375004 16.3401 0.557504'
                  fill='#205497'
                />
              </svg>
              <p className='text-primary md:text-[32px] font-bold'>
                We're here to make a difference: by making law affordable and
                accessible to everyone.
              </p>
              <svg
                className='ml-auto'
                xmlns='http://www.w3.org/2000/svg'
                width='24'
                height='24'
                viewBox='0 0 24 24'
                fill='none'
              >
                <path
                  fill-rule='evenodd'
                  clip-rule='evenodd'
                  d='M14.5729 19.442C18.3379 17.024 20.4294 14.21 20.8479 10.9985C21.4994 6 17.0294 3.55349 14.7644 5.75149C12.4994 7.94999 13.8569 10.74 15.4969 11.503C17.1369 12.2655 18.1399 12 17.9649 13.0195C17.7899 14.0385 15.4569 16.8645 13.4069 18.1805C13.3343 18.2423 13.2879 18.3294 13.2773 18.4242C13.2667 18.519 13.2927 18.6142 13.3499 18.6905L13.8569 19.35C14.0769 19.636 14.2879 19.625 14.5729 19.4425M4.65993 19.442C8.42493 17.024 10.5169 14.2095 10.9349 10.9985C11.5864 6 7.11643 3.55349 4.85143 5.75149C2.58643 7.94999 3.94392 10.74 5.58442 11.503C7.22442 12.2655 8.22743 12 8.05243 13.0195C7.87743 14.0385 5.54393 16.8645 3.49393 18.1805C3.42135 18.2423 3.3751 18.3295 3.36461 18.4243C3.35411 18.5191 3.38015 18.6143 3.43743 18.6905L3.94443 19.35C4.16442 19.636 4.37543 19.625 4.65993 19.4425'
                  fill='#205497'
                />
              </svg>
              <div className='md:hidden '>
                <hr className='mt-5' />
                <p className='text-text-muted mt-3 text-[12px]'>Who said...</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <LawTech />

      <FundedBy />

      <PioneerSection />
    </>
  )
}

export default WhoWeAre
